import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MsalGuard,
    MsalGuardConfiguration,
    MsalModule,
    MsalService
} from '@azure/msal-angular';
import { AuthService } from './shared/services/auth.service';
import { sidexApiAuthInterceptor } from './shared/services/sidex-api-auth.interceptor';
import { unauthorizedInterceptor } from './shared/services/unauthorized-interceptor.service';
import { SharedModule } from './shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

function initializeAppFactory(authService: AuthService): () => Promise<boolean> {
    return async () => {
        return firstValueFrom(authService.initAuth());
    };
}

function msalInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication(environment.msalConfig);
}

function msalGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: environment.loginRequest,
        loginFailedRoute: '/no-access'
    };
}

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(FormsModule, NgxPaginationModule, MatDialogModule, SharedModule, MsalModule),
        {
            provide: MSAL_INSTANCE,
            useFactory: msalInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: msalGuardConfigFactory
        },
        MsalService,
        MsalGuard,
        provideAppInitializer(() => {
            const initializerFn = initializeAppFactory(inject(AuthService));
            return initializerFn();
        }),
        provideHttpClient(withInterceptors([sidexApiAuthInterceptor, unauthorizedInterceptor])),
        provideAnimations(),
        provideRouter(appRoutes)
    ]
};
